import axios from 'axios';
import store from '@/store/store';

const axios2 = axios.create();
delete axios2.defaults.headers.common['Authorization'];

const dvgApi = window.location.hostname == 'localhost' ? store.state.baseUrlTestApi : store.state.baseUrlApi;
const hohApi = window.location.hostname == 'localhost' ? store.state.baseUrlHoHTestApi : store.state.baseUrlHoHApi;

//const dvgApi = store.state.baseUrlApi;
//const hohApi = store.state.baseUrlHoHApi;
let lang = store.state.config.selectedLanguage;
if (lang == null) lang = store.state.config.defaultLanguage;

export default {
  async SUBMIT_DIGIT_CODE({ dispatch }, payload) {
    return await axios
      .post(`${dvgApi}/healthcheck-restful-api/seroform/validateCode`, payload)
      .then(res => {
        if (res.status == 200) {
          return res.data;
        } else if (res.status == 204) {
          dispatch('showError', store.getters.content.code_used[lang]);
        }
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', store.getters.content.error_code[lang]);
      });
  },

  async CHECK_FORM({ dispatch }, patientCaseId) {
    return await axios
      .get(`${dvgApi}/healthcheck-restful-api/seroform/findForm/${patientCaseId}`)
      .then(res => {
        if (res.status == 200) {
          return res.data;
        }
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', store.getters.content.error_checking_form[lang]);
      });
  },

  async SUBMIT_FORM({ dispatch, commit }, payload) {
    return await axios
      .post(`${dvgApi}/healthcheck-restful-api/seroform`, payload)
      .then(res => {
        if (res.status == 200) {
          return res.data;
        }
      })
      .catch(error => {
        console.log(error);
        commit('SET_SHOW_LOADER', {
          action: false
        });
        dispatch('showError', store.getters.content.error_submitting_form[lang]);
      });
  },

  async SUBMIT_APPOINTMENT_CODE({ dispatch }, payload) {
    return await axios
      .post(`${hohApi}/labhoh-restful-api/reservationcode`, payload)
      .then(res => {
        if (res.status == 200) {
          return res.data;
        }
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', store.getters.content.error_submitting_code[lang]);
      });
  },

  async CLAIM_APPOINTMENT_CODE({ dispatch, commit }, payload) {
    return await axios
      .put(`${hohApi}/labhoh-restful-api/reservationcode`, payload)
      .then(res => {
        if (res.status == 200) {
          //return res.data;
          commit('SET_CODE', res.data.id);
        }
      })
      .catch(error => {
        console.log(error);
        commit('SET_SHOW_LOADER', {
          action: false
        });
        dispatch('showError', store.getters.content.error_claiming_code[lang]);
        return false;
      });
  },

  async GET_APPOINTMENT_CODE_INFO({ dispatch, commit }, payload) {
    return await axios
      .get(`${hohApi}/labhoh-restful-api/reservationcode/${payload.code}`)
      .then(res => {
        if (res.status == 200) {
          //return res.data;
          commit('SET_CODE', res.data.id);
        }
      })
      .catch(error => {
        console.log(error);
        commit('SET_SHOW_LOADER', {
          action: false
        });
        dispatch('showError', store.getters.content.error_claiming_code[lang]);
        return false;
      });
  },
  async GET_CASES({ commit }) {
    commit('SET_SHOW_LOADER', {
      action: true,
      text: ''
    });
    return await axios
      .get(`${dvgApi}/healthcheck-restful-api/patientcase/unit`)
      .then(res => {
        commit('SET_SHOW_LOADER', {
          action: false
        });
        if (res.status == 200) {
          commit('SET_CASES', res.data);
        }
      })
      .catch(error => {
        console.log(error);
        commit('SET_SHOW_LOADER', {
          action: false
        });
      });
  },

  async GET_DOCTOR_OPTIONS({ commit }) {
    return await axios
      .get(`${dvgApi}/healthcheck-restful-api/hoh/doctorlist`)
      .then(res => {
        if (res.status == 200) {
          commit('SET_DOCTOR_OPTIONS', res.data);
          return res.data;
        }
      })
      .catch(error => {
        console.log(error);
        // const errorMsg = store.getters.content.error_doctors_list[lang];
        // let payload = {
        //   open: true,
        //   text: errorMsg,
        //   color: 'error'
        // }
        // commit('SET_SNACKBAR', payload)
      });
  },

  async CREATE_CASE({ commit }, payload) {
    commit('SET_SHOW_LOADER', {
      action: true
      // text: 'Creating new user'
    });
    return await axios
      .put(`${dvgApi}/healthcheck-restful-api/patientcase/unit/self-register`, payload)
      .then(res => {
        commit('SET_SHOW_LOADER', {
          action: false,
          text: null
        });
        if (res.status == 200) {
          const msg = store.getters.content.successfully_added[lang];
          let payload = {
            open: true,
            text: msg,
            color: 'success'
          };
          commit('SET_SNACKBAR', payload);
          return res.data;
        } else {
          const errorMsg = store.getters.content.user_not_added[lang];
          let payload = {
            open: true,
            text: errorMsg,
            color: 'error'
          };
          commit('SET_SNACKBAR', payload);
        }
      })
      .catch(error => {
        commit('SET_SHOW_LOADER', {
          action: false,
          text: null
        });
        const errorMsg = store.getters.content.user_not_added[lang];
        let payload = {
          open: true,
          text: errorMsg,
          color: 'error'
        };
        commit('SET_SNACKBAR', payload);
        console.error(error.response);
        return error;
      });
  },

  //Calendar page
  async GET_CALENDAR_ENTRIES({ dispatch }, payload) {
    return await axios
      .get(`${hohApi}/labhoh-restful-api/agendaslot/${payload.code}/group/${payload.minDate}/${payload.maxDate}?location=${payload.location}`)
      .then(res => {
        if (res.status == 200) {
          return res.data;
        }
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', store.getters.content.error_loading_calendar[lang]);
      });
  },

  async GET_CALENDAR_DAY_SLOTS({ dispatch, commit }, payload) {
    if (payload.showLoader != false) {
      commit('SET_TIME_SLOTS', []);
      commit('SET_TIME_SLOTS_LOADER', true);
    }
    return await axios
      .get(`${hohApi}/labhoh-restful-api/agendaslot/${payload.code}/${payload.minDate}/${payload.maxDate}?location=${payload.location}`)
      .then(res => {
        if (payload.showLoader != false) commit('SET_TIME_SLOTS_LOADER', false);
        if (res.status == 200) {
          if (res.data.length) commit('SET_TIME_SLOTS', res.data);
        }
      })
      .catch(error => {
        console.log(error);
        if (payload.showLoader != false) commit('SET_TIME_SLOTS_LOADER', false);
        dispatch('showError', store.getters.content.error_loading_calendar[lang]);
        return false;
      });
  },

  async SUBMIT_APPOINTMENT({ dispatch }, payload) {
    return await axios
      .put(`${hohApi}/labhoh-restful-api/reservationcode/reserve`, payload)
      .then(res => {
        if (res.status == 204 || res.status == 200) return true;
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', store.getters.content.error_submitting_appointment[lang]);
        return false;
      });
  },

  async GET_APPOINTMENT({ dispatch }, patientCaseId) {
    return await axios
      .get(`${hohApi}/labhoh-restful-api/reservationcode/patientCaseId/${patientCaseId}`)
      .then(res => {
        if (res.status == 200) return res.data;
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', store.getters.content.error_submitting_appointment[lang]);
        return false;
      });
  },

  async GET_LOCATIONS({ dispatch }, payload) {
    return await axios
      .get(`${hohApi}/labhoh-restful-api/testcenter/code/${payload.code}`)
      .then(res => {
        if (res.status == 200) return res.data;
      })
      .catch(error => {
        console.log(error);
        // commit('SET_SHOW_LOADER', {
        //   action: false
        // });
        dispatch('showError', store.getters.content.error_retrieving_testcenter_locations[lang]);
        return false;
      });
  },

  async GET_ADDRESS_LIST({ state }, payload) {
    let search = '';
    if (payload != null || payload != undefined) {
      search = '/?streetName_contains=' + payload + '&_limit=-1';
    } else {
      search = '/?_limit=-1';
    }
    return await axios2
      .get(`${state.baseUrlContentApi}/street-names${search}`)
      .then(res => {
        if (res.status == 200) {
          return res.data;
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  async REGISTER({ commit }, payload) {
    return await axios2
      .post(`${dvgApi}/healthcheck-restful-api/user-registration`, payload)
      .then(res => {
        if (res.status == 200) {
          return res.data;
        }
      })
      .catch(error => {
        console.log(error);
        let errorMsg = store.getters.content.error_register_form[lang];
        if (error.message != undefined) {
          errorMsg = error.message;
        }
        commit('SET_SHOW_LOADER', {
          action: false
        });
        let payload = {
          open: true,
          text: errorMsg,
          color: 'error'
        };
        commit('SET_SNACKBAR', payload);
      });
  },

  showError({ commit }, text) {
    let payload = {
      open: true,
      text: text,
      color: 'error'
    };
    commit('SET_SNACKBAR', payload);
  }
};
